require('./bootstrap.js');
require('../modernizr-webp.js');
require('../assign-general-functions-to-window.js');

import supportedBrowserNotification from '../core/supported-browser-notification';
const validBrowser = supportedBrowserNotification();
import LiveChatClass from '../live-chat/modules/live-chat-class';
window.liveChatClass = new LiveChatClass;
setTimeout(() => {
    liveChatClass.initLiveChat((typeof liveChatLocationId !== 'undefined') ? liveChatLocationId : false);
}, 500);
import ContactFormValidator from '../validation/ContactFormValidator';
import CustomerLocationHandler from '../modules/CustomerLocationHandler';
import GoogleMapsLoaderClass from '../modules/GoogleMapsLoader';
import LocationDataLoader from '../modules/LocationDataLoader';

import router from './routes.js';
import store from './store/index.js';

const VueScrollTo = require("vue-scrollto");
Vue.use(VueScrollTo);
import { customEvent, generateLeadEvent, trackPageView } from '../modules/tracking/AnalyticsEvents';

if (validBrowser) {
    window.LocationDataLoader = new LocationDataLoader;
    window.ContactFormValidator = ContactFormValidator;
    window.CustomerLocationHandler = CustomerLocationHandler;
    window.customerLat = getCookieValue('lat');
    window.customerLng = getCookieValue('lng');
    window.customerPostcode = getCookieValue('postcode');
    window.customerGeolocation = getCookieValue('geolocation');
    // Create a global object for getting a new Google Maps instance
    window.GoogleMapsLoader = new GoogleMapsLoaderClass;
    // Handle detecting when Google Maps has finished loading
    window.googleMapsLoaded = () => {
        GoogleMapsLoader.mapLoaded();
    };

    require('../modules/polyfills/string-padStart');

    Vue.mixin({
        methods: {
            gaTag(eventCategory = '', eventAction = '', eventLabel = '') {
                customEvent(eventCategory, eventAction, eventLabel, 0);
            },
            generateLeadEvent(name = 'Misc Event', value = 0, currency = 'GBP') {
                generateLeadEvent(name, currency, value);
            },
            trackPageView() {
                trackPageView();
            }
        }
    });

    const titleEl = document.querySelector('title');
    const canonicalEl = document.querySelector('link[rel="canonical"]');
    let firstLoad = true;

    router.afterEach((to, from) => {
        if (typeof liveChatClass !== 'undefined') {
            liveChatClass.setCustomerType('New');
        }

        canonicalEl.setAttribute('href', 'https://www.stellantisandyou.co.uk' + to.path);

        // Send Page View event
        if (firstLoad) {
            firstLoad = false;
            return;
        }
        if (to.name == 'new-details') {
            return;
        }

        trackPageView(location.pathname, titleEl.innerHTML);
    });

    const app = new Vue({
        el: '#app',
        data: {
            brand: 'randd',
        },
        store,
        router,
        created: function () {
            this.$store.dispatch('CustomerData/initialize');
            this.$store.dispatch('Layout/initialize');
        },
    });
}